import http from './http'

export const authApi = {
  login(username, password) {
    return http.post('/auth/login/', { username, password }).then((res) => res.data)
  },
  sso(token) {
    return http.post('/auth/sso/', { token }).then((res) => res.data)
  },
  me() {
    return http.get('/auth/me/').then((res) => res.data)
  },
  logout() {
    return http.post('/auth/logout/')
  },
}
